const messagesIT = {
    code: "it",
    messages: {
        included: (field) => `"${field}" Immettere un valore valido nel campo`,
        url: (field) => `"${field}" il campo deve essere un URL valido`,
        alpha: (field) => `"${field}" può contenere solo lettere`,
        alpha_dash: (field) =>
            `"${field}" il campo può contenere lettere e trattini (-) o caratteri di sottolineatura (_)`,
        alpha_num: (field) => `"${field}" può contenere solo lettere o numerir`,
        alpha_spaces: (field) => `"${field}" solo le lettere possono contenere spazi`,
        between: (field, min, max) => `"${field}" ${min} con ${max} dovrebbe essere nell'intervallo`,
        confirmed: (field, field2) => `"${field}" la verifica è errata ${field2} E ${field} deve essere lo stesso`,
        digits: (field, length) => `"${field}" numerico e ${length} dovrebbe essere calpestato`,
        dimensions: (field, width, height) =>
            `"${field}" la zona ${width} con pixel ${height} dovrebbe essere tra i pixel`,
        email: (field) => `"${field}" Il campo deve essere un indirizzo email valido`,
        excluded: (field) => `"${field}" non è un valore valido.`,
        ext: (field) => `"${field}" il campo deve essere un file valido`,
        image: (field) => `"${field}" il campo deve essere un file immagine`,
        oneOf: (field) => `"${field}" Immettere un valore valido nel campo`,
        max: (field, length) => `"${field}" la zona ${length} non più di un carattere`,
        max_value: (field, max) => `"${field}" la zona ${max} dovrebbe essere un valore pari o inferiore`,
        mimes: (field) => `"${field}" deve essere un file valido`,
        min: (field, length) => `"${field}" zona almeno ${length} carattere deve essere inserito`,
        min_value: (field, min) => `"${field}" la zona ${min} deve essere un valore di o più`,
        numeric: (field) => `"${field}" Immettere un valore numerico nel campo`,
        regex: (field) => `"${field}" il formato non è valido`,
        required: (field) => `"${field}" è richiesto spazio`,
        required_if: (field) => `"${field}" è richiesto spazio`,
        size: (field, size) => `"${field}" la zona ${size}Dovrebbe essere inferiore a KB`,
        length: (field, len) => `"${field}" la zona ${len} carattere deve essere`,
    },
};

export default messagesIT;
